<!-- Layout -->
<template>
    <div>
        <el-container>
            <el-header v-if="!hideLayout">
                <Headers />
            </el-header>
            <el-main>
                <Content />
            </el-main>
            <el-footer v-if="!hideLayout">
                <Footers />
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import Headers from '@/components/Header.vue'
import Content from '@/components/Content.vue'
import Footers from '@/components/FooterNew.vue'
import { isMobile } from '@/utils/utils.js'
export default {
    name: 'layout',
    components: {
        Headers,
        Content,
        Footers
    },
    computed: {
        hideLayout() {
            const path = this.$route.path;
            const isAgreementPage = ['/agreement','/condiciones'].includes(path);
            return isMobile() && isAgreementPage;
        }
    },
    data () {
        return {

        }
    },
    created () {

    },
    mounted () {

    },
    methods: {
        isMobile
    }
}
</script>
<style  scoped>
.el-header {
    padding: 0;
}
.el-main {
    padding: 0;
}
.el-footer {
    padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/layout.vue